import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

export default ({ pageContext, location }) => {
  return (
    <>
      <SEO location={location} image="top.jpg" />
      <Layout pageContext={pageContext}>
        <h1>Top Page</h1>
        <Image name="top.jpg" />
        <Link to="/page1">Page1</Link>
        <Link to="/page2">Page2</Link>
      </Layout>
    </>
  );
};
